// extracted by mini-css-extract-plugin
export default {"mainStakingBox":"Staking_mainStakingBox__cHRkD","userStakeDetails":"Staking_userStakeDetails__WSpko","stakeDetailBox":"Staking_stakeDetailBox__+YASK"};